exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2{\r\n    font-size: 27px;\r\n}\r\n.fondoSiNo{\r\n    background-color: white;\r\n    height: 440px;\r\n    width: 440px;\r\n    -ms-flex-align: center;\r\n        align-items: center;\r\n    display: -ms-grid;\r\n    display: grid;\r\n    /* align-content: center; */\r\n    text-align: center;\r\n    padding: 30px 50px;\r\n}\r\n.comentario{\r\n    background-color: #CCF0F8;\r\n    padding: 24px 50px 10px 50px;\r\n    border-radius: 10px;\r\n}\r\n.comentario > p{\r\n    font-size: 20px;\r\n}\r\n.botonSi{background-color: rgba(0, 255, 0, 0.5);}\r\n.botonNo{background-color: rgba(255, 255, 255, 0.5);}\r\n.mat-raised-button {\r\n    height: 55px;\r\n    font-size: 18px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/github/490/rec_ng_recibopago490v7/src/app/components/table-items/dialogo-si-no/dialogo-si-no.component.css
// module id = ../../../../../src/app/components/table-items/dialogo-si-no/dialogo-si-no.component.css
// module chunks = main